export class RealtimePositionUtils {
  public static isInMotion(
    currentTcpSpeed: number[],
    previousTcpSpeeds: number[][]
  ): boolean {
    for (let i = 0; i < currentTcpSpeed.length; i++) {
      let val = currentTcpSpeed[i];

      /* tslint:disable-next-line */
      for (let j = 0; j < previousTcpSpeeds?.length; j++) {
        val = val * previousTcpSpeeds[j][i];
      }

      val = Number(val.toFixed(4));

      if (val !== 0) {
        return true;
      }
    }

    return false;
  }
}
